import React from 'react';
import { Link as ScrollBase, LinkProps } from 'react-scroll';

export const ScrollLink: React.FC<LinkProps> = (props) => {
  const Scroll = ScrollBase as unknown as React.ElementType;
  return <Scroll {...props}>{props.children}</Scroll>;
};
